import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import axios from '../../config/AxiosConfig';
import {
  EDIT_REVENUE_INVESTOR_SUBSCRIPTION_API,
  GET_REVENUE_INVESTOR_SUBSCRIPTIONS_API,
  GET_REVENUE_TRANSACTIONS_API,
  REVENUE_API,
} from '../../store/actions/apiCollections';

const getFetcher = (url) =>
  axios.get(url).then((response) => response?.data?.data);

const patchFetcher = async (url, { arg }) =>
  axios.patch(`${url}/${arg.id}`, arg).then((response) => response?.data?.data);

const refundProcessPatchFetcher = async (url, { arg }) =>
  axios.patch(url, arg).then((response) => response?.data);

const deleteFetcher = async (url, { arg }) =>
  axios.delete(`${url}/${arg.id}`).then((response) => response?.data?.data);

const postFetcher = async (url, { arg }) =>
  axios.post(url, arg).then((response) => response?.data?.data);

export const useGetRevenueSettings = () => {
  const { data, isValidating, mutate } = useSWR(REVENUE_API, getFetcher, {
    refreshInterval: 0,
    keepPreviousData: true,
    revalidateOnFocus: true,
  });

  return { data, isValidating, mutate };
};

export const useUpdateRevenueSettings = () => {
  const { data, trigger, isMutating, error } = useSWRMutation(
    REVENUE_API,
    patchFetcher
  );

  return {
    data,
    trigger,
    isMutating,
    error,
  };
};

export const useGetSubscriptionPlans = (type, languageId) => {
  const { data, isValidating, mutate } = useSWR(
    languageId
      ? `${GET_REVENUE_INVESTOR_SUBSCRIPTIONS_API}/${type}?language=${languageId}`
      : null,
    getFetcher,
    {
      refreshInterval: 0,
      keepPreviousData: true,
      revalidateOnFocus: true,
    }
  );

  return { data, isValidating, mutate };
};

export const useCreateInvestorSubscription = (type, languageId) => {
  const { data, trigger, isMutating, error } = useSWRMutation(
    languageId
      ? `${GET_REVENUE_INVESTOR_SUBSCRIPTIONS_API}/${type}?language=${languageId}`
      : null,
    postFetcher
  );

  return {
    data,
    trigger,
    isMutating,
    error,
  };
};

export const useUpdateInvestorSubscription = () => {
  const { data, trigger, isMutating, error } = useSWRMutation(
    EDIT_REVENUE_INVESTOR_SUBSCRIPTION_API,
    patchFetcher
  );

  return {
    data,
    trigger,
    isMutating,
    error,
  };
};

export const useUpdateRefundSubscription = () => {
  const { data, trigger, isMutating, error } = useSWRMutation(
    UPDATE_REVENUE_SUBSCRIPTION_REFUND_API,
    patchFetcher
  );

  return {
    data,
    trigger,
    isMutating,
    error,
  };
};

export const useDeleteInvestorSubscription = () => {
  const { data, trigger, isMutating, error } = useSWRMutation(
    EDIT_REVENUE_INVESTOR_SUBSCRIPTION_API,
    deleteFetcher
  );

  return {
    data,
    trigger,
    isMutating,
    error,
  };
};

export const useGetRevenueTransactions = (limit, query) => {
  const { data, isValidating, mutate } = useSWR(
    `${GET_REVENUE_TRANSACTIONS_API}?limit=${limit}${query ? `&${query}` : ''}`,
    getFetcher,
    {
      refreshInterval: 0,
      keepPreviousData: true,
      revalidateOnFocus: true,
    }
  );

  return { data, isValidating, mutate };
};

export const useGetExportRevenueTransactions = (query) => {
  const { data, isValidating, mutate } = useSWR(
    `${GET_REVENUE_TRANSACTIONS_API}/export${query ? `?${query}` : ''}`,
    getFetcher,
    {
      refreshInterval: 0,
      keepPreviousData: true,
      revalidateOnFocus: true,
    }
  );

  return { data, isValidating, mutate };
};

export const useUpdateRevenueTransaction = () => {
  const { data, trigger, isMutating, error } = useSWRMutation(
    `${GET_REVENUE_TRANSACTIONS_API}/request-refund`,
    refundProcessPatchFetcher
  );

  return {
    data,
    trigger,
    isMutating,
    error,
  };
};
